/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import APIKeys from "../../Modals/apikeys";

interface PaymentMethod {
    name: string;
    logo?: string;
    status: "active" | "inactive" | "pending";
    type: "Payment Gateway" | "Digital Wallet";
    settings?: {
        [key: string]: string;
    };
    integrationId?: string;
    iframeId?: string;
    baseUrl?: string;
    apiKey?: string;
}

const paymentMethodsData: PaymentMethod[] = [
    {
        name: "Paymob",
        status: "active",
        type: "Payment Gateway",
        integrationId: "123456",
        iframeId: "1234",
        baseUrl: "https://accept.paymob.com/api",
        apiKey: "ZXlKaGJHY2lPaUpJVXpVN... (Visible only to admin)"
    },
    {
        name: "Stripe",
        status: "active",
        type: "Payment Gateway",
        integrationId: "123456",
        iframeId: "1234",   
        baseUrl: "https://accept.paymob.com/api",
        apiKey: "ZXlKaGJHY2lPaUpJVXpVN... (Visible only to admin)"
    }
];

const PaymentMethods = () => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <>
            {/* ---------- Page Header ---------- */}
            <div className="main_title">
                <h1>Payment Methods</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Payment Methods
                </p>
            </div>

            <div className="stats_boxes gap_m">
                {/* ACTIVE GATEWAYS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            2
                            <p>Active Gateways</p>
                            <small>Processing payments</small>
                        </h2>
                        <figure className="blue">
                            <CreditCardOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* TOTAL TRANSACTIONS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            AED 1.2M
                            <p>Total Processed</p>
                            <small>This Month</small>
                        </h2>
                        <figure className="sucess">
                            <AccountBalanceOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* SUCCESS RATE */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            98.5%
                            <p>Success Rate</p>
                            <small>Last 30 days</small>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* FAILED TRANSACTIONS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            1.5%
                            <p>Failed / Disputes</p>
                            <small>Action required</small>
                        </h2>
                        <figure className="danger">
                            <ErrorOutlineIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            <div className="cards serviceCardsContainer mt_20">
                <div className="cardsGrid">
                    {paymentMethodsData.map((method) => (
                        <div
                            key={method.name}
                            className={`card ${method.status}`}
                        >
                            <div className="cardHeader">
                                <h3>{method.name}</h3>
                                <span className={`status ${method.status}`}>{method.status}</span>
                            </div>

                            <div className="cardBody">
                                <div className="row">
                                    <span>Type</span>
                                    <strong>{method.type}</strong>
                                </div>
                            
                                    <>
                                        <div className="row">
                                            <span>Integration ID</span>
                                            <strong>{method.integrationId}</strong>
                                        </div>
                                        <div className="row">
                                            <span>Iframe ID</span>
                                            <strong>{method.iframeId}</strong>
                                        </div>
                                        <div className="row">
                                            <span>Base URL</span>
                                            <strong style={{ fontSize: '11px' }}>{method.baseUrl}</strong>
                                        </div>
                                        <div className="row">
                                            <span>API Key</span>
                                            <strong style={{ fontSize: '11px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '150px' }}>{method.apiKey}</strong>
                                        </div>
                                    </>
                            
                            </div>

                            <div className="cardFooter">
                                <SwitchToggle />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <APIKeys
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default PaymentMethods;
